'use strict';

exports = module.exports = require('./lib/parser')['default'];
exports['default'] = exports;



//////////////////
// WEBPACK FOOTER
// ../~/_intl-messageformat-parser@1.4.0@intl-messageformat-parser/index.js
// module id = 1164
// module chunks = 0